import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as Service from "../../../store/service";
import * as BusinessCreditReportAction from "../../../store/businessCreditReportService/actions";
import CreditSummary from "./CreditSummary";
import Tab from "../../common/Tab/Tab";
import { Link } from "react-router-dom";
import BusinessCreditReportDialog from "../../Dialogs/BusinessCreditReportDialog";
import ErrorBoundary from "../../common/ErrorBoundary";
import { DialogComponent } from "../../common/DialogComponent";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";

interface ICreditHistory {
    alertID: number;
    alertCategory: string;
    displayName: string;
    alertDate: string;
}

const BCreditReport: React.FunctionComponent<{ reportObject: BusinessCreditReportStatePII }> = (props) => {
    const dispatch = useDispatch();
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const requestBusinessCreditReport = (ReportPK: any, forcefullyRefresh: boolean, creditProvider: string) =>
        dispatch(BusinessCreditReportAction.actionCreators.requestBusinessCreditReport(ReportPK, forcefullyRefresh, creditProvider));
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const creditReport: IBusinessCreditReportResponse = useSelector(
        (state: ApplicationState) => (state.businessCreditReportState && state.businessCreditReportState.creditReportData)!
    ).find((it) => it.Provider === creditProvider)!;
    const [showCreditReportDialog, setShowCreditReportDialog] = useState(false);
    const [selectedTab, setSelectedTab] = useState("5");
    const [creditHistory, setCreditHistory] = useState([] as any);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreditReportDialog = (value: string): any => {
        if (value === "show") {
            setShowCreditReportDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowCreditReportDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowCreditReportDialog(false);
        }
    };

    const changeTab = (tabIndex: string) => {
        setSelectedTab(tabIndex);
    };

    const requestIframeData = () => {
        if (selectedTab === "5") {
            requestBusinessCreditReport(null, false, creditProvider);
        } else if (selectedTab === "6") {
            setIsLoading(true);
            Service.getAllBusinessCreditHistory()
                .then((data) => {
                    setIsLoading(false);
                    if (data && data.length > 0) {
                        //Bug: 27035-Getting two credit reports for a  newly added business
                        //Below Filter applied for solving issue when new business user account created, after that it's created two same credit report
                        //So resolve this issue by removing one from response
                        //Note: it's happen only D&B user.
                        if (creditProvider === "DUNBRADSTREET") {
                            data = data.filter(
                                (thing: any, index: any, self: any) =>
                                    index ===
                                    self.findIndex(
                                        (t: any) =>
                                            t.alertDate === thing.alertDate &&
                                            t.createdTime === thing.createdTime &&
                                            t.alertTitle === thing.alertTitle &&
                                            t.alertCategory === thing.alertCategory
                                    )
                            );
                        }

                        data = data.filter((obj: any) => {
                            return obj.displayName === "Business Credit Report";
                        });
                        setCreditHistory(data);
                    }
                })
                .catch(function (error) {
                    setIsLoading(false);
                });
        }
    };

    const openReportinNewTab = (alertId: number) => {
        requestBusinessCreditReport(alertId, true, creditProvider);
        handleCreditReportDialog("show");
        return false;
    };

    useEffect(requestIframeData, [selectedTab]);

    return (
        <React.Fragment>
            <Tab tabId="credit-report-sub-items">
                <li className="tab-item" role="menuitem" onClick={() => changeTab("5")} id={"credit-report-latest-tab"} aria-label="Latest Credit Report">
                    <Link to="#" className={"btn-default btn-tab " + (selectedTab === "5" ? "tab-active" : "")}>
                        <span className="btn-text">Latest Credit Report</span>
                    </Link>
                </li>
                <li className="tab-item" role="menuitem" onClick={() => changeTab("6")} id={"credit-report-historical-tab"} aria-label="All Credit Reports">
                    <Link to="#" className={"btn-default btn-tab " + (selectedTab === "6" ? "tab-active" : "")}>
                        <span className="btn-text">All Credit Reports</span>
                    </Link>
                </li>
            </Tab>
            <div className="row" id="content">
                <div className="col-xs">
                    {selectedTab === "5" ? (
                        <React.Fragment>
                            <CreditSummary
                                bCreditReportData={creditReport}
                                reportObject={props.reportObject}
                                isForPrinting={false}
                                requestBusinessCreditReport={() => requestBusinessCreditReport(null, true, creditProvider)}
                                isPrintAndRefreshButtonShow={true}
                                creditProvider={creditProvider}
                            />
                        </React.Fragment>
                    ) : null}

                    {selectedTab === "6" ? (
                        <div className="box">
                            <div className="box-content">
                                {isLoading ? (
                                    <div className="box loading"></div>
                                ) : (
                                    <React.Fragment>
                                        {creditHistory == null || creditHistory.length === 0 ? (
                                            <React.Fragment>You Currently have no credit reports to review.</React.Fragment>
                                        ) : (
                                            <div className="table-container scroll">
                                                <div className="ant-table">
                                                    <div className="ant-table-container">
                                                        <div className="ant-table-content">
                                                            <table style={{ tableLayout: "auto" }}>
                                                                <thead className="ant-table-thead">
                                                                    <tr>
                                                                        <th className="ant-table-cell">Date Received</th>
                                                                        <th className="ant-table-cell">Type</th>
                                                                        <th className="ant-table-cell">Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="ant-table-tbody">
                                                                    <React.Fragment>
                                                                        {creditHistory &&
                                                                            creditHistory.map((history: any, index: number) => {
                                                                                return (
                                                                                    <tr className="ant-table-row" key={"history-" + history.alertID}>
                                                                                        <td className="ant-table-cell">
                                                                                            {history.alertDate &&
                                                                                                getFormattedDate(i18nService.get("Country"), history.alertDate)}
                                                                                        </td>
                                                                                        <td className="ant-table-cell">{history.displayName}</td>
                                                                                        <td className="ant-table-cell">
                                                                                            <a
                                                                                                className="default_link"
                                                                                                href="javascript:void(0)"
                                                                                                onClick={() => openReportinNewTab(history.alertID)}
                                                                                            >
                                                                                                View
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                    </React.Fragment>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <ErrorBoundary componentName="Business Credit Report Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                {showCreditReportDialog && (
                    <DialogComponent
                        dialogId="business-credit-report-dialog"
                        title="Business Credit Report"
                        datalayerEvent="Close Business Credit Report dialog"
                        closeDialog={() => {
                            handleCreditReportDialog("close");
                        }}
                    >
                        <BusinessCreditReportDialog
                            dialogId="business-credit-report-dialog"
                            closeDialog={() => {
                                handleCreditReportDialog("close");
                            }}
                            reportObject={props.reportObject}
                        ></BusinessCreditReportDialog>
                    </DialogComponent>
                )}
            </ErrorBoundary>
        </React.Fragment>
    );
};

export default BCreditReport;
